import React, { useState, useEffect } from 'react';
import './Navbar.css';
import { Link } from 'react-router-dom';

import DetoxaLogo from '../../assets/logo.png';

import BannerImage from '../../assets/1.png';
import {
	setUsername,
	setBearerToken,
	setIsLoggedIn,
	setPasswordofuser,
} from '../../redux/admin/userActions.js';
import { useDispatch } from 'react-redux';
import GooglePlay from '../../assets/play.png';
import AppleApp from '../../assets/apple.png';

import axios from 'axios';
import { BASE_URL } from '../../constants';

import defaultBannerImage from '../../assets/bg gradient.png';
import { useSelector } from 'react-redux';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const Navbar = (props) => {
	const dispatch = useDispatch();
	const username = useSelector((state) => state.user.username);
	const isloggedin = useSelector((state) => state.user.isLoggedIn);
	const { bearerToken } = props;
	const shortLinks = [
		{ title: 'About Us' },
		{ title: 'Investors' },
		{ title: 'Careers' },
		{ title: 'CSR' },
	];
	const actualLinks = [
		{ title: 'Home', to: '/' },
		{ title: 'Growth Tracker', to: '/growthtracker' },
		{ title: 'Eyesight Tracker', to: '/eyesighttracker' },
		{ title: 'Consultation', to: '/' },
		{ title: 'Subscription', to: '/subscription' },
		{ title: 'Covid-19', to: '/' },
		{ title: 'Blog', to: '/blogs' },
		{ title: 'Child Kits', to: '/' },
		{ title: 'Contact', to: '/' },
	];

	const handlelogout = () => {
		console.log('logout');
		dispatch(setIsLoggedIn(false));
		dispatch(setBearerToken(''));
		dispatch(setPasswordofuser(''));
		dispatch(setUsername(''));
	};

	const [bannerImages, setBannerImages] = useState([defaultBannerImage]);
	useEffect(() => {
		axios
			.get(`${BASE_URL}/public/home/slider`, {
				params: {
					deviceType: 'MOBILE',
				},
			})
			.then((response) => {
				console.log(response);
				if (response.data.length > 0) setBannerImages(response.data);
			})
			.catch((error) => {
				console.log(error);
			});
	}, []);
	const settings = {
		dots: true,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
	};
	return (
		<div className='Navbar'>
			<div className='Navbar-short-links'>
				<div className='width-90'>
					{shortLinks.map((aLink) => (
						<Link>
							{aLink.title} <i class='fas fa-chevron-down'></i>
						</Link>
					))}
				</div>
			</div>
			<div className='Navbar-actual-links'>
				<a href='#' data-target='mobile-demo' class='sidenav-trigger hide-on-large-only'>
					<i class='material-icons'>menu</i>
				</a>
				<div className='logo'>
					<img src={DetoxaLogo} alt='Detoxa logo comes here' />
				</div>
				<div className='links hide-on-med-and-down'>
					{actualLinks.map((aLink) => {
						if (aLink.title === 'Growth Tracker')
							return (
								<a class='dropdown-trigger' href='' data-target='dropdown1'>
									Tracker
								</a>
							);
						else if (aLink.title === 'Eyesight Tracker') return null;
						return <Link to={aLink.to}>{aLink.title}</Link>;
					})}
					<ul id='dropdown1' class='dropdown-content'>
						<li>
							<Link to='/growthtracker'>Growth</Link>
						</li>
						<li>
							<Link to='/eyesighttracker'>Eyesight</Link>
						</li>
					</ul>
				</div>
				{isloggedin ? (
					<div className='auth'>
						<span
							style={{ marginLeft: '-20px', marginRight: '20px', fontSize: '20px' }}
						>
							Welcome {'    '}
							{}
							{username}
						</span>
						<span className='logout'>
							<Link to='/' onClick={handlelogout}>
								Logout
							</Link>
						</span>
					</div>
				) : (
					<div className='auth'>
						<Link to='/login'>Log In</Link>
						<Link to='/signup'>Sign Up</Link>
						<Link>
							<i class='material-icons'>shopping_cart</i>
						</Link>
					</div>
				)}
			</div>
			<ul class='sidenav' id='mobile-demo'>
				{actualLinks.map((aLink) => (
					<li>
						<Link to={aLink.to}>{aLink.title}</Link>
					</li>
				))}
			</ul>
			<Slider {...settings}>
				{bannerImages.map((anImage) => (
					<div className='Navbar-banner'>
						<div
							className='row'
							style={{
								background: `url(${anImage.image})`,
								backgroundSize: 'cover',
								backgroundPosition: 'center',
								height: '100%',
								margin: '0px auto',
							}}
						>
							<div className='col s12 l4 welcome'>
								<p>Welcome to</p>
								<p className='detoxa'>Detoxa</p>
								<p className='download'>Download our App</p>
								<div className='row'>
									<Link>
										<img
											className='col s6'
											src={GooglePlay}
											alt='Google Play Store come here'
										/>
									</Link>
									<Link>
										<img
											className='col s6'
											src={AppleApp}
											alt='Apple App Store come here'
										/>
									</Link>
								</div>
							</div>
							<div className='col s8 image hide-on-med-and-down'>
								<img src={BannerImage} />
							</div>
						</div>
					</div>
				))}
			</Slider>
			<br />
		</div>
	);
};

export default Navbar;
